import { AnchorButton, Menu, MenuItem } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Popover2 } from '@blueprintjs/popover2';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';
import * as copy from 'src/templates/copy';

type ProjectClassMappingRelationshipMenuProps = {
  onDuplicate: () => void;
  onRemove?: () => void;
};

export const ProjectClassMappingRelationshipMenu: React.VFC<
  ProjectClassMappingRelationshipMenuProps
> = ({ onDuplicate, onRemove }) => {
  return (
    <Popover2
      content={
        <Menu>
          <MenuItem
            data-testid={TEST_IDS.projectMapping.relationships.menu.duplicate}
            onClick={onDuplicate}
            text={copy.components.projectMapping.menu.duplicateMapping}
          />
          {onRemove ? (
            <MenuItem
              data-testid={TEST_IDS.projectMapping.relationships.menu.remove}
              onClick={onRemove}
              text={copy.components.projectMapping.menu.removeMapping}
            />
          ) : null}
        </Menu>
      }
      minimal
    >
      <AnchorButton
        data-testid={TEST_IDS.projectMapping.relationships.menu.button}
        icon={IconNames.MORE}
        minimal
      />
    </Popover2>
  );
};
